import { useState } from "react";
import { useDispatch } from "react-redux";

import ScreenshotViewer from "../../../../common/ScreenshotViewer/ScreenshotViewer";
import Spinner from "../../../../common/Spinner/Spinner";

import CameraIcon from "../../../../Icon-SVG/CameraIcon";

import { addNotification } from "../../../../../store/actions/notifierActions";

import { getNestedValue } from "../../../../../utils/function";
import axiosApi from "../../../../../utils/axios";

const ICON_SIZE = 24;

const PhishBoxScreenshot = (props) => {
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);
  const [screenshotData, setScreenshotData] = useState("");
  const [loading, setLoading] = useState(false);

  const accessor = props.column.id;
  const system = getNestedValue(props.row.original, accessor, "-");
  const link = props.row.original.link || props.row.original._source.target_url;

  const screenshotClickHandler = async (e) => {
    e.stopPropagation();

    if (loading) return;

    setLoading(true);
    try {
      const query = new URLSearchParams({
        system,
        link,
      });
      const response = await axiosApi.get(`/api/phishbox/screenshot?${query.toString()}`);
      setScreenshotData(response.data.screenshot);
      setShowModal(true);
    } catch (e) {
      dispatch(
        addNotification({
          message: e?.response?.data?.message,
          options: { variant: "error" },
          time: 3000,
        }),
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="phishbox__table__screenshot">
      <div onClick={screenshotClickHandler}>
        <button className="primary-button">
          {loading ? (
            <Spinner width={ICON_SIZE} height={ICON_SIZE} />
          ) : (
            <CameraIcon width={ICON_SIZE} height={ICON_SIZE} color="white" />
          )}
        </button>
      </div>
      <ScreenshotViewer
        show={showModal}
        onClose={() => setShowModal(false)}
        images={screenshotData ? [{ src: screenshotData, caption: link }] : []}
        title="Analysis Screenshot"
      />
    </div>
  );
};

export default PhishBoxScreenshot;
